import React, { useState, useEffect, useContext } from "react";
import { useQuery } from "@apollo/client";
import { Autocomplete, TextField } from "@mui/material";
import moment from "moment";
//==================== graphql =====================
import { translateLauguage } from "../../Function/Translate";
import { GET_EXPENSE_GROUP_WITH_PAGINATION } from "../../Schema/ExpenseGroup";
import { AuthContext } from "../../Context/AuthContext";
import {
  GET_CHART_OF_ACCOUNT_WITH_PAGINATION,
  GET_ACCOUNT_TYPE,

} from "../../Schema/ChartOfAccount";

import { getKhmerMonth } from "../../Function/DynamicFn";
import {
  GET_SCHOOL,
  GET_STUDENTS,
  GET_CUSTOMER,
  ITEM_FOR_SELECT,
  SELECT_MAIN_USER,
  GET_INCOME_HEADS,
  GET_BILL_TO_STUDENT,
  GET_SHIFT_FOR_SELECT,
  SELECT_ACADEMIC_TERMS,
  GET_INCOMESHIFT_BY_DATE,
  GET_DISCOUNT_FOR_SELECT,
  GET_PROGRAMME_FOR_SELECT,
  GET_ENROLLMENT_BY_STUDENT,
  GET_INCOME_HEAD_FOR_SELECT,
  GET_CLASS_BY_ACADEMIC_YEAR,
  GET_ACADEMIC_YEAR_FOR_SELECT,
  GET_STUDENTS_BY_ACADEMIC_YEAR,
  GET_CHART_OF_ACCOUNT_FOR_SELECT,
  GET_STUDENT_ENROLLMENT_FOR_INVOICE,
  GET_CLASS_GROUP_BY_PROGRAMME_FOR_SELECT,
  GET_QUARTER_BY_ACADEMIC_TERM_FOR_SELECT,
  GET_ACADEMIC_TERMS_BY_ACADEMIC_YEAR_FOR_SELECT,
} from "../../Schema/SelectSchema";

// =====================  select School======================
export function SelectExpenseGroup({ selectedVal, setSelectedVal, className }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { data, refetch } = useQuery(GET_EXPENSE_GROUP_WITH_PAGINATION, {
    variables: {
      page: 1,
      limit: 10,
      keyword: "",
      pagination: false,
    },
    onCompleted: ({ getGroupExpensePagination }) => {
      // console.log("getGroupExpensePagination::", getGroupExpensePagination);
      let rows = [];
      if (getGroupExpensePagination?.data?.length !== 0) {
        getGroupExpensePagination?.data?.map((d) => {
          const allRows = {
            id: d?._id,
            title: d?.title,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      value={selectedVal}
      options={selectOptions}
      className={className}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? t("thead_select_value") : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("label_select_value")}
        />
      )}
    />
  );
}

//========================================= Selected Main User ====================================
export function SelectMainUser({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(SELECT_MAIN_USER, {
    variables: {
      page: 1,
      limit: 1,
      keyword: "",
      pagination: false,
    },
    onCompleted: ({ getMainUserWithPagination }) => {
      // console.log("getMainUserWithPagination:", getMainUserWithPagination);
      let rows = [];
      if (getMainUserWithPagination?.data?.length !== 0) {
        getMainUserWithPagination?.data?.map((d) => {
          const allRows = {
            id: d?.user_id,
            title: d?.firstName + " " + d?.lastName,
            img: d?.imageSrc,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select value" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}

//=========================== select account type ================================
export function SelectAccountType({ selectedVal, setSelectVal, className }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkedRefectch, setCheckedRefectch] = useState(false);

  const { refetch: refetchAccount } = useQuery(GET_ACCOUNT_TYPE, {
    onCompleted: ({ getAccountType }) => {
      // console.log("getAccountType::", getAccountType);
      let rows = [];
      if (getAccountType?.length !== 0) {
        getAccountType?.map((d) => {
          const allRows = {
            id: d,
            title: d,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        selectOptions([]);
      }
    },
    onError: (error) => {
      console.error("Error", error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectVal(val);
    setCheckedRefectch(!checkedRefectch);
  };

  useEffect(() => {
    refetchAccount();
  }, [checkedRefectch]);

  return (
    <Autocomplete
      fullWidth
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "" : option.title
      }
      renderInput={(param) => (
        <TextField {...param} size="small" placeholder="select account type" />
      )}
    />
  );
}

//=========================== select accounts ================================
export function SelectAccountName({
  selectedVal,
  setSelectVal,
  accountType,
  disabled,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkedRefectch, setCheckedRefectch] = useState(false);

  const { refetch } = useQuery(GET_CHART_OF_ACCOUNT_WITH_PAGINATION, {
    variables: {
      page: 1,
      limit: 10,
      keyword: "",
      pagination: false,
      accountType: accountType,
    },
    onCompleted: ({ getChartOfAccountWithPagination }) => {
      // console.log(
      //   "getChartOfAccountWithPagination::",
      //   getChartOfAccountWithPagination
      // );
      let rows = [];
      if (getChartOfAccountWithPagination?.data?.length !== 0) {
        getChartOfAccountWithPagination?.data?.map((d) => {
          // if (d?.is_top_parents === true || d?.is_parents === true) {
          const allRows = {
            id: d?._id,
            title: d?.account_name,
          };

          if (d?.sub_account?.length !== 0) {
            d?.sub_account?.map((data) => {
              const allRows = {
                id: data?._id,
                title: data?.account_name,
              };
              rows.push(allRows);
            });
            setSelectOptions(rows);
          }
          // }
          rows.push(allRows);
        });
        setSelectOptions(rows);
      } else {
        selectOptions([]);
      }
    },
    onError: (error) => {
      console.error("Error", error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectVal(val);
    setCheckedRefectch(!checkedRefectch);
  };

  useEffect(() => {
    refetch();
  }, [checkedRefectch]);

  return (
    <Autocomplete
      disabled={disabled}
      fullWidth
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "" : option.title
      }
      renderInput={(param) => (
        <TextField {...param} size="small" placeholder="select account type" />
      )}
    />
  );
}

// =============================== select academic year ============================
export function SelectAcademicYear({
  disabled,
  className,
  selectedVal,
  setSelectedVal,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_ACADEMIC_YEAR_FOR_SELECT, {
    onCompleted: ({ getAcademicYearsForSelect }) => {
      let rows = [];
      if (getAcademicYearsForSelect?.length !== 0) {
        getAcademicYearsForSelect?.map((d) => {
          const allRows = {
            id: d?._id,
            endDate: d?.endDate,
            startDate: d?.startDate,
            title: d?.academicYearTitle,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "select value" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}

// ================================ select programme ==============================
export function SelectProgramme({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_PROGRAMME_FOR_SELECT, {
    onCompleted: ({ getProgrammesForSelect }) => {
      // console.log("getProgrammesForSelect", getProgrammesForSelect);
      let rows = [];
      if (getProgrammesForSelect?.length !== 0) {
        getProgrammesForSelect?.map((d) => {
          let allRows = {
            id: d?._id,
            title: d?.programmeName,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      disabled={disabled}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "select value" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}


export function SelectAcademicTermsByAcademicYear({
  disabled,
  className,
  selectedVal,
  setSelectedVal,
  academicYearId,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_ACADEMIC_TERMS_BY_ACADEMIC_YEAR_FOR_SELECT, {
    variables: {
      academicYearId: academicYearId
    },
    onCompleted: ({ getAcademicTermsByAcademicYearForSelete }) => {
      let rows = [];
      if (getAcademicTermsByAcademicYearForSelete?.length !== 0) {
        getAcademicTermsByAcademicYearForSelete?.map((d) => {
          let allRows = {
            id: d?._id,
            endDate: d?.endDate,
            startDate: d?.startDate,
            title: d?.academicTermTitle,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option) => option?.title || ""}
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}



export function SelectQuarterByAcademicTerms({
  disabled,
  className,
  selectedVal,
  setSelectedVal,
  academicTermId,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_QUARTER_BY_ACADEMIC_TERM_FOR_SELECT, {
    variables: {
      academicTermId: academicTermId || null
    },
    onCompleted: ({ getQuarterByAcademicTermsForSelete }) => {
      let rows = [];
      if (getQuarterByAcademicTermsForSelete?.length !== 0) {
        getQuarterByAcademicTermsForSelete?.map((d) => {
          let allRows = {
            id: d?._id,
            endDate: d?.endDate,
            title: d?.quarterName,
            startDate: d?.startDate,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      disabled={disabled}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "select value" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}


export function SelecAcademicTerms({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(SELECT_ACADEMIC_TERMS, {
    variables: {
      keyword: "",
    },
    onCompleted: ({ getAcademicTerms }) => {
      let rows = [];
      if (getAcademicTerms?.length !== 0) {
        getAcademicTerms?.map((d) => {
          let allRows = {
            id: d?._id,
            title: d?.programId?.programmName,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      disabled={disabled}
      onChange={(event, val) => handleSelect(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}

// ================================ select class group ==============================
export function SelectClassGroup({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
  programmeId,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_CLASS_GROUP_BY_PROGRAMME_FOR_SELECT, {
    variables: {
      programme: programmeId ? programmeId : "",
    },
    onCompleted: ({ getClassGroupsByProgrammeForSelect }) => {
      let rows = [];
      if (getClassGroupsByProgrammeForSelect?.length !== 0) {
        getClassGroupsByProgrammeForSelect?.map((d) => {
          let allRows = {
            id: d?._id,
            title: d?.classGroupName,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      disabled={disabled}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "select value" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}
// ================================ select shift ==============================
export function SelectShift({ selectedVal, setSelectedVal, className }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_SHIFT_FOR_SELECT, {
    onCompleted: ({ getShiftsForSelect }) => {
      // console.log("getShiftsForSelect", getShiftsForSelect);
      let rows = [];
      if (getShiftsForSelect?.length !== 0) {
        getShiftsForSelect?.map((d) => {
          // console.log("getShiftsForSelect.", d);
          let allRows = {
            id: d?._id,
            title: d?.shiftName,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "select value" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select value" />
      )}
    />
  );
}

// ================================ select Service ================================
export function SelectService({ selectedVal, setSelectedVal, className }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_INCOME_HEAD_FOR_SELECT, {
    onCompleted: ({ getIncomeHeadForSelect }) => {
      // console.log("getIncomeHeadForSelect:", getIncomeHeadForSelect);
      let rows = [];
      if (getIncomeHeadForSelect?.length !== 0) {
        getIncomeHeadForSelect?.map((d) => {
          const allRows = {
            id: d?._id,
            title: d?.incomeName,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select price" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select price" />
      )}
    />
  );
}

// ================================ select chart of account ================================
export function SelectChartOfAccount({
  selectedVal,
  setSelectedVal,
  className,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_CHART_OF_ACCOUNT_FOR_SELECT, {
    onCompleted: ({ getChartOfAccountForSelect }) => {
      // console.log("getChartOfAccountForSelect:", getChartOfAccountForSelect);
      let rows = [];
      if (getChartOfAccountForSelect?.length !== 0) {
        getChartOfAccountForSelect?.map((d) => {
          const allRows = {
            id: d?._id,
            title: d?.incomeName,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  // const { totalPriceKHR } = tableData.reduce(
  //   (acc, e) => {
  //     e?.disburmentList?.forEach((f) => {
  //       acc.totalPriceKHR += f.priceKHR || 0;
  //       acc.totalPriceUSD += f.priceUSD || 0;
  //     });
  //     return acc;
  //   },
  //   { totalPriceKHR: 0, totalPriceUSD: 0 }
  // );

  // const formatNumber = (number) => new Intl.NumberFormat().format(number);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select chart of account" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="select chart of account"
        />
      )}
    />
  );
}

// ================================ select enrollment by student ================================
export function SelectEnrollmentByStudent({
  selectedVal,
  setSelectedVal,
  academicYearId,
  studentId,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_ENROLLMENT_BY_STUDENT, {
    variables: {
      academicYearId: academicYearId ? academicYearId : "",
      studentId: studentId ? studentId : "",
    },
    onCompleted: ({ getEnrollmentsByStudent }) => {
      console.log("getEnrollmentsByStudent:", getEnrollmentsByStudent);
      let rows = [];
      if (getEnrollmentsByStudent?.length !== 0) {
        getEnrollmentsByStudent?.map((d) => {
          const allRows = {
            id: d?._id,
            title: d?.className,
            shiftName: d?.shiftName,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select bill to" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="select chart of account"
        />
      )}
    />
  );
}

// ================================ select bill to student ================================
export function SelectBillTo({
  selectedVal,
  setSelectedVal,
  studentId,
  className,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_BILL_TO_STUDENT, {
    variables: {
      studentId: studentId ? studentId : "",
    },
    onCompleted: ({ getBillTo }) => {
      // console.log("getBillTo:", getBillTo);
      let rows = [];
      if (getBillTo?.length !== 0) {
        getBillTo?.map((d) => {
          const allRows = {
            id: d?._id,
            title: d?.bill_name,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select bill to" : option.title
      }
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="select bill to" />
      )}
    />
  );
}

//==========================================Selected Programme list====================================
export function SelectProgrammeList({
  selectedVal,
  setSelectedVal,
  className,
  checkedDisabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_PROGRAMME_FOR_SELECT, {
    onCompleted: ({ getProgrammesForSelect }) => {
      if (getProgrammesForSelect?.length === 0) setSelectOptions([]);
      if (getProgrammesForSelect?.length !== 0) {
        const ValueOption = getProgrammesForSelect?.map((d) => ({
          id: d?._id,
          title: d?.programmeName,
        }));
        setSelectOptions(ValueOption);
      }
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={checkedDisabled ? false : true}
      multiple
      size="small"
      id="tags-standard"
      value={selectedVal}
      options={selectOptions}
      className={className}
      // isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option?.title}
      onChange={(event, val) => handleSelect(val)}
      renderInput={(params) => (
        <TextField {...params} placeholder="select programme" />
      )}
    />
  );
}

// =============================== SELECT CLASS BY ACADEMIC YEAR  ==========================
export function SelectClassByAcademic({
  selectedVal,
  setSelectedVal,
  academicYearId,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_CLASS_BY_ACADEMIC_YEAR, {
    variables: {
      academicYearId: academicYearId ? academicYearId : "",
    },
    onCompleted: ({ getClassesByAcademicYear }) => {
      let rows = [];
      if (getClassesByAcademicYear?.length !== 0) {
        getClassesByAcademicYear?.map((d) => {
          const allRows = {
            id: d?._id,
            title: d?.className,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [academicYearId, checkRefetch]);

  return (
    <Autocomplete
      fullWidth
      className={className}
      value={selectedVal}
      options={selectOptions}
      disabled={disabled}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select class" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select class"
          fullWidth
        />
      )}
    />
  );
}

// =================================== SELECT INCOME SHIFT ======================================
export function SelectIncomeShift({
  selectedVal,
  setSelectedVal,
  fromDate,
  toDate,
  className,
  disabled,
}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_INCOMESHIFT_BY_DATE, {
    variables: {
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(toDate).format("YYYY-MM-DD"),
    },
    onCompleted: ({ getIncomeShift }) => {
      // console.log("getIncomeShift::", getIncomeShift);
      let rows = [];
      if (getIncomeShift?.length !== 0) {
        getIncomeShift?.map((d) => {
          const allRows = {
            id: d?._id,
            title: d?.closeTime
              ? `${moment(d?.openTime).format("DD-MMM-YYYY")} ${moment(
                d?.openTime
              ).format("HH:mm a")} - ${moment(d?.closeTime).format(
                "DD-MMM-YYYY"
              )} ${moment(d?.closeTime).format("HH:mm a")}`
              : `${moment(d?.openTime).format("DD-MMM-YYYY")} ${moment(
                d?.openTime
              ).format("HH:mm a")} - Not close yet!`,
          };
          rows.push(allRows);
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch, fromDate, toDate]);

  return (
    <Autocomplete
      fullWidth
      className={className}
      value={selectedVal}
      options={selectOptions}
      disabled={disabled}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select Incomeshift" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select Incomeshift"
          fullWidth
        />
      )}
    />
  );
}


// =================================== SELECT INCOME SHIFT ======================================
export function SelectCustomer({ selectedVal, setSelectedVal, className, disabled }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_CUSTOMER, {
    onCompleted: ({ getAllCustomerOfGeneralInvoice }) => {
      let rows = [];
      if (getAllCustomerOfGeneralInvoice?.length !== 0) {
        getAllCustomerOfGeneralInvoice?.map((d) => {
          rows.push({
            id: d?._id,
            title: d?.customerNameKhmer,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch,]);

  return (
    <Autocomplete
      fullWidth
      className={className}
      value={selectedVal}
      options={selectOptions}
      disabled={disabled}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select customer" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select customer"
          fullWidth
        />
      )}
    />
  );
}


// =================================== SELECT INCOME SHIFT ======================================
export function SelectCustomerByStudent({ selectedVal, setSelectedVal, className, disabled, data }) {
  const [selectOptions, setSelectOptions] = useState([]);
  useEffect(() => {
    setSelectOptions([
      {
        id: data?.father?._id,
        title: data?.father?.lastName + " " + data?.father?.firstName,
        tel: data?.father?.tel,
      },
      {
        id: data?.mother?._id,
        tel: data?.mother?.tel,
        title: data?.mother?.lastName + " " + data?.mother?.firstName,
      },
      {
        id: data?.guardian?._id,
        tel: data?.guardian?.tel,
        title: data?.guardian?.lastName + " " + data?.guardian?.firstName,
      },
    ])
  }, [data]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions.filter((d) => d?.id)}
      onChange={(event, val) => setSelectedVal(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select customer"
          fullWidth
        />
      )}
    />
  );
}


export function SelectMonthByQuarter({ selectedVal, setSelectedVal, className, disabled, quarterVal }) {
  const [selectOptions, setSelectOptions] = useState([]);


  const getDateRangeByStartEnd = (start, end) => {
    var dateStart = moment(start);
    var dateEnd = moment(end);
    var timeValues = [];

    while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
      timeValues.push(dateStart.format('YYYY-MM-DD'));
      dateStart.add(1, 'month');
    }
    return timeValues
  }


  const getKhMonth = getDateRangeByStartEnd(quarterVal?.startDate, quarterVal?.endDate);


  useEffect(() => {
    setSelectOptions(getKhMonth.map((e) => ({
      date: e,
      id: Date.now() + Math.random(),
      title: getKhmerMonth(moment(e).format("MM")),
    })));

  }, [quarterVal]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions.filter((d) => d?.id)}
      onChange={(event, val) => setSelectedVal(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          fullWidth
          {...params}
          size="small"
          placeholder="Select customer"
        />
      )}
    />
  );
}


export function SelectStudent({ selectedVal, setSelectedVal, className, disabled }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_STUDENTS, {
    onCompleted: ({ getStudents }) => {
      let rows = [];
      if (getStudents?.length !== 0) {
        getStudents?.map((d) => {
          rows.push({
            id: d?._id,
            title: d?.firstName + " " + d?.lastName,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch,]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select student" : option?.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select student"
          fullWidth
        />
      )}
    />
  );
}



export function SelectStudentByAcademic({ selectedVal, setSelectedVal, className, disabled, academicYearId }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_STUDENTS_BY_ACADEMIC_YEAR, {
    variables: {
      academicYearId: academicYearId || null
    },
    onCompleted: ({ getStudentByAcademicYearWeb }) => {
      let rows = [];
      if (getStudentByAcademicYearWeb?.length !== 0) {
        getStudentByAcademicYearWeb?.map((d, index) => {
          rows.push({
            id: d?._id,
            title: index + 1 + " - " + d?.lastName + " " + d?.firstName,
            data: d,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch, academicYearId]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select student" : option?.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select student"
          fullWidth
        />
      )}
    />
  );
}



export function SelectSchools({ selectedVal, setSelectedVal, className, disabled }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_SCHOOL, {
    onCompleted: ({ getSchools }) => {
      let rows = [];
      if (getSchools?.length !== 0) {
        getSchools?.map((d) => {
          rows.push({
            id: d?._id,
            title: d?.schoolName,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch,]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select student" : option?.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select student"
          fullWidth
        />
      )}
    />
  );
}




export function SelectItem({ selectedVal, setSelectedVal, className, disabled, required }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(ITEM_FOR_SELECT, {
    onCompleted: ({ itemsForSelect }) => {
      let rows = [];
      if (itemsForSelect?.length !== 0) {
        itemsForSelect?.map((d) => {
          rows.push({
            id: d?._id,
            title: d?.itemName,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch,]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select item" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select item"
          fullWidth
          error={required && !selectedVal?.id}
        />
      )}
    />
  );
}



export function SelectIncomeHeads({ selectedVal, setSelectedVal, className, disabled, required }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_INCOME_HEADS, {
    onCompleted: ({ getIncomeHeads }) => {
      let rows = [];
      if (getIncomeHeads?.length !== 0) {
        getIncomeHeads?.map((d) => {
          rows.push({
            id: d?._id,
            unit: d?.unit,
            price: d?.price,
            title: d?.incomeHead,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });
  // console.log(selectOptions, "selectOptions");
  const handleSelect = (val) => {
    console.log("val income head", val)
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch,]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select item" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select item"
          fullWidth
          error={required && !selectedVal?.id}
        />
      )}
    />
  );
}



export function SelectStudentEnrollmentForInvoice({

  disabled,
  className,
  selectedVal,
  setSelectedVal,

  studentId,
  programId,
  academicYearId,

}) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_STUDENT_ENROLLMENT_FOR_INVOICE, {
    variables: {
      studentId: studentId,
      programId: programId,
      academicYearId: academicYearId,
    },
    onCompleted: ({ getStudentEnrollmentForInvoice }) => {

      let rows = [];
      if (getStudentEnrollmentForInvoice?.length !== 0) {
        getStudentEnrollmentForInvoice?.map((d) => {
          rows.push({
            id: d?.classId,
            gradeId: d?.gradeId,
            classId: d?.classId,
            shiftName: d?.shiftName,
            enrollmentId: d?.enrollmentId,
            title: d?.gradeName + " " + d?.className,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch,]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          fullWidth
          {...params}
          size="small"
          placeholder="Select item"
        />
      )}
    />
  );
}



export function SelectDiscount({ selectedVal, setSelectedVal, className, disabled, required }) {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const { refetch } = useQuery(GET_DISCOUNT_FOR_SELECT, {
    onCompleted: ({ getDiscountForSelect }) => {
      let rows = [];
      if (getDiscountForSelect?.length !== 0) {
        getDiscountForSelect?.map((d) => {
          rows.push({
            id: d?._id,
            amount: d?.amount,
            title: d?.title,
          });
          setSelectOptions(rows);
        });
      } else {
        setSelectOptions([]);
      }
    },
    onError: (error) => {
      console.log("error: ", error);
    },
  });

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetch();
  }, [checkRefetch,]);

  return (
    <Autocomplete
      fullWidth
      value={selectedVal}
      disabled={disabled}
      className={className}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? "Select item" : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Select item"
          fullWidth
          error={required && !selectedVal?.id}
        />
      )}
    />
  );
}